var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Index"},[_c('Header',{attrs:{"id":"nav"}}),_c('div',{staticClass:"main-content"},[_c('Banner'),_c('Home'),_c('div',{staticClass:"to-top",attrs:{"alt":""},on:{"click":_vm.goTop}},[_vm._m(0)])],1),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('i',{staticClass:"iconfont iconarrow_up"}),_vm._v(" "),_c('span',[_vm._v("TOP")])])
}]

export { render, staticRenderFns }